import { filter, find, get } from "lodash";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import {
  CONTACT_POINT_SYSTEM,
  DATE_FORMAT,
  RELATIONSHIP,
} from "utils/constants";
import CustomModal from "../CustomModal";

const Profile = ({
  contact,
  open,
  setOpen,
  onEdit,
  onRelatedPersonEdit,
  hideEditButton,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.PROFILE_CART", { returnObjects: true });

  const getTelecom = (system) =>
    get(find(get(contact, "telecoms", []), { system }), "value", "");

  const children = filter(get(contact, "relatedPersons", []), {
    relationship: RELATIONSHIP.CHILD,
  });
  const spouse = get(contact, "relatedPersons", []).find(
    ({ relationship }) => relationship === RELATIONSHIP.SPOUSE,
  );

  return (
    <>
      <CustomModal
        open={open}
        setOpen={setOpen}
        width={500}
        title={TRANSLATION.TITLE}
        closeText={TRANSLATION.CLOSE}
        hideEditButton={hideEditButton}
      >
        <div className="lmfinfo__member">
          <div className="lmfinfo__member--block">
            <div className="lmfinfo__member--block--adherent">
              <span className="lmfinfo__member--block--adherent__title">
                <span>{TRANSLATION.ADHERENT.TITLE}</span>
                {!hideEditButton && (
                  <span onClick={() => onEdit()}>{TRANSLATION.EDIT}</span>
                )}
              </span>
              <ul>
                <li>
                  <span>{TRANSLATION.ADHERENT.NAME}</span>
                  <span className="value capitalize">
                    {get(contact, "user.firstname")}{" "}
                    {get(contact, "user.lastname")}
                  </span>
                </li>
                <li>
                  <span>{TRANSLATION.BIRTH_DATE}</span>
                  <span className="value">
                    {moment(get(contact, "user.birthDate")).format(DATE_FORMAT)}
                  </span>
                </li>
                <li>
                  <span>{TRANSLATION.ADHERENT.EMAIL}</span>
                  <span className="value">
                    {getTelecom(CONTACT_POINT_SYSTEM.EMAIL)}
                  </span>
                </li>
                <li>
                  <span>{TRANSLATION.ADHERENT.PHONE}</span>
                  <span className="value">
                    {getTelecom(CONTACT_POINT_SYSTEM.PHONE)}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          {spouse && (
            <>
              <div className="lmfinfo__member--block">
                <div className="lmfinfo__member--block--adherent">
                  <span className="lmfinfo__member--block--adherent__title">
                    <span>{TRANSLATION.SPOUSE}</span>
                    {!hideEditButton && (
                      <span onClick={() => onRelatedPersonEdit()}>
                        {TRANSLATION.EDIT}
                      </span>
                    )}
                  </span>
                  <ul>
                    <li>
                      <span>{TRANSLATION.FULL_NAME}</span>
                      <span className="capitalize">
                        {get(spouse, "identity.user.firstname")}{" "}
                        {get(spouse, "identity.user.lastname")}
                      </span>
                    </li>
                    <li>
                      <span>{TRANSLATION.BIRTH_DATE}</span>
                      <span>
                        {moment(get(spouse, "identity.user.birthDate")).format(
                          DATE_FORMAT,
                        )}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          )}
          {children.length > 0 && (
            <div className="lmfinfo__member--block">
              <span className="lmfinfo__member--block--adherent__title">
                <span>{TRANSLATION.CHILDREN}</span>
                {!hideEditButton && (
                  <span onClick={() => onRelatedPersonEdit()}>
                    {TRANSLATION.EDIT}
                  </span>
                )}
              </span>
              <div className="lmfinfo__member--block--children">
                {children.map((child, index) => (
                  <div
                    className="lmfinfo__member--block--children--child"
                    key={`cart-child-${index}`}
                  >
                    <span className="lmfinfo__member--block--children__title">
                      <span>{TRANSLATION[`COUNT_${index + 1}`]}</span>
                    </span>
                    <ul>
                      <li>
                        <span>{TRANSLATION.FULL_NAME}</span>
                        <span className="capitalize">
                          {get(child, "identity.user.firstname")}{" "}
                          {get(child, "identity.user.lastname")}
                        </span>
                      </li>
                      <li>
                        <span>{TRANSLATION.BIRTH_DATE}</span>
                        <span>
                          {moment(get(child, "identity.user.birthDate")).format(
                            DATE_FORMAT,
                          )}
                        </span>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </CustomModal>
    </>
  );
};
export default Profile;
